export enum MixpanelEvent {
  ScreenView = 'screen_view',
}
